import cx from "classnames"
import type { PropsWithChildren } from "react"

export type MarketingNoteProps = PropsWithChildren<{
  variant: "success" | "tertiary" | "tertiaryVariant"
  title?: string
  icon?: React.JSX.Element
  compact?: boolean
  className?: string
}>

export const MarketingNote = ({
  children,
  title,
  icon,
  className,
  variant,
  compact = false,
}: MarketingNoteProps) => (
  <div
    className={cx(
      `cobalt-marketing-note cobalt-marketing-note--${variant}`,
      className,
      { "cobalt-marketing-note--compact": compact },
    )}
  >
    {icon && (
      <div className="cobalt-marketing-note__icon-container">{icon}</div>
    )}

    <div className="cobalt-marketing-note__content">
      {title && <div className="c-font-bold">{title}</div>}
      {children}
    </div>
  </div>
)
